export const Messages = {
  title: 'Welcome to Percona Monitoring and Management (PMM)',
  pmm: 'Percona Monitoring and Management',
  pmmIs:
    ' is an open-source database monitoring, management, and observability solution for MySQL, PostgreSQL, MongoDB and other popular databases.',
  pmmEnables: 'PMM enables you to:',
  spotCriticalPerformance:
    'Spot critical performance issues faster, understand the root cause of incidents better and troubleshoot them more efficiently;',
  ensureDbPerformance:
    'Ensure optimal database performance with automated health checks and notifications about potential security threats, performance degradation, data loss, and data corruption issues;',
  backup: 'Back up your critical data with zero-downtime and minimal performance impact.',
  moreInfo: 'For more information, please check out the ',
  pmmOnlineHelp: 'PMM online help',
  skip: 'Skip',
  checkLater: 'Check later',
  startTour: 'Start tour',
};
